import React from 'react';
import { Avatar } from 'antd';
import { useSelector } from 'react-redux';
import ProfileAccess from './components/ProfileAccess';
import Notification from './components/Notification';
import ResetPassword from './components/ResetPassword';
import TFAuthentication from './components/TFAuthentication';
import DownloadApp from './components/DownloadApp';

export default function Settings() {

    const userDetails = useSelector((state) => state.user.userDetails);

    return (
        <div className='border bg-White rounded-xl p-4'>
            <div className='mb-6'>
                <p className='text-lg font-semibold'>Account Details</p>
                <div className='mt-4 flex items-center gap-6'>
                    <div className='relative'>
                        <Avatar size='large' className='uppercase size-32 text-4xl'>{(userDetails?.first_name)?.charAt(0)}{(userDetails?.last_name)?.charAt(0)}</Avatar>
                        <button className='bg-primary p-2 rounded-full cursor-pointer absolute bottom-1 right-2'>
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="white" className="size-5">
                                <path d="M21.731 2.269a2.625 2.625 0 0 0-3.712 0l-1.157 1.157 3.712 3.712 1.157-1.157a2.625 2.625 0 0 0 0-3.712ZM19.513 8.199l-3.712-3.712-12.15 12.15a5.25 5.25 0 0 0-1.32 2.214l-.8 2.685a.75.75 0 0 0 .933.933l2.685-.8a5.25 5.25 0 0 0 2.214-1.32L19.513 8.2Z" />
                            </svg>
                        </button>
                    </div>
                    <p className='text-lg font-medium'>{userDetails?.name}</p>
                </div>
            </div>
            <div className='grid lg:grid-cols-2 gap-5'>
                <ProfileAccess />
                <Notification />
                <ResetPassword />
                <TFAuthentication />
                <DownloadApp />
            </div>
        </div>
    )
}